export default __webpack_public_path__ + "static/media/slide2.2f8e4474.jpg";